<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item v-if="user && [1, 2, 3, 4].includes(user.user_group_id)" class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" :btns="btns" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :width="'560px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onChange="onModalChange" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'payment',
      getListUrl: 'repayrec',
      breadcrumb: [
        { name: "财务管理", path: `/finance/carrier` },
        { name: "应付账款管理", path: `/finance/carrier` },
        { name: "打款记录" },
      ],
      formCtrl: [
        {
          ...this.ctrls.month,
          label: "打款日期：",
          keyName: "paytime",
        },
      ],
      cols: [
        { keyName: "company", label: "公司名称", minwidth: 120 },
        { keyName: "pname", label: "承运联系人", minwidth: 120 },
        { keyName: "paymoney", label: "打款金额", align: 'right', className: 'pr30', width: 120 },
        { keyName: "paytime", label: "打款日期", minwidth: 120 },
        { keyName: "remark", label: "备注", minwidth: 120 },
        { keyName: "nickname", label: "操作人", minwidth: 120 },
      ],
      getTotalProperty: ["paymoney"],
      btns: [
        {
          ...this.viewBtn,
          title: "打款记录",
          cb: ({ id, pname, paymoney, paytime, photo, remark, pid }) => {
            // console.log(id)
            this.title = '查看打款记录'
            this.viewMode = true
            this.mform = { id, pname, paymoney, paytime, photo, remark, pid }
            // console.log({ ...this.mform })
            this.showDialog()
          },
        },
      ],
      title: '查看打款记录',
      mform: {
        paymoney: undefined,
        paytime: undefined,
        photo: undefined,
      },
      mrules: {
        paymoney: [
          {
            required: true,
            message: '请填写打款金额',
            trigger: 'blur',
          }
        ],
        paytime: [
          {
            required: true,
            message: '请选择打款日期',
            trigger: 'blur',
          }
        ],
        photo: [
          {
            required: true,
            message: '请上传打款凭证',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "还款人",
          keyName: "pname",
          type: "text",
          disabled: true,
        },
        {
          label: "打款金额",
          keyName: "paymoney",
          err: "请填写打款金额",
          type: "number",
        },
        {
          label: "打款日期",
          keyName: "paytime",
          err: "请选择打款日期",
          type: "date",
        },
        {
          label: "打款凭证",
          keyName: "photo",
          tips: "最多上传10张图片",
          type: "file",
          ptype: "payment",
          max: 10,
        },
        {
          label: "备注",
          keyName: "remark",
          err: "请填写备注信息",
          type: "textarea",
          rows: 3,
        },
      ],
      viewMode: false,
      baseParams: ['shipperid'],
    };
  },
  methods: {
    addItem() {
      this.title = '添加打款记录'
      this.viewMode = false
      const { pname, shipperid } = this.$route.query
      this.mform = {
        pname,
        pid: shipperid,
        paymoney: undefined,
        paytime: undefined,
        photo: undefined,
      }
      // console.log({ ...this.mform })
      this.showDialog()
    },
  },
  created() {
    const { user_group_id } = this.user
    if ([1, 2, 3, 4].includes(user_group_id)) {
      this.btns[0] = {
        ...this.editBtn,
        title: "打款记录",
        cb: ({ id, pname, paymoney, paytime, photo, remark, pid }) => {
          // console.log(id)
          this.title = '打款记录'
          this.viewMode = false
          this.mform = { id, pname, paymoney, paytime, photo, remark, pid }
          // console.log({ ...this.mform })
          this.showDialog()
        },
      }
    }
  },
  mounted() {
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
  .el-form {
    .el-form-item {

      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100% !important;
      }
    }
  }

  .btns {
    .mians {
      text-align: center;
    }
  }
}
</style>
